export const formatBRL = value => {
  if (value === null || value === undefined || value === '') return '—'
  const number = Number(value)
  if (Number.isNaN(number)) return '—'
  return number.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}

export const formatDateTime = value => {
  if (!value) return '—'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return '—'
  return date.toLocaleString('pt-BR')
}

export const formatDate = value => {
  if (!value) return '—'
  // `YYYY-MM-DD` puro é interpretado como UTC pelo construtor e, em BRT, volta
  // um dia antes. Datas sem hora (validade, competência) são lidas como locais.
  const somenteData = typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)
  const date = somenteData ? new Date(`${value}T00:00:00`) : new Date(value)
  if (Number.isNaN(date.getTime())) return '—'
  return date.toLocaleDateString('pt-BR')
}

export const formatNumber = value => {
  if (value === null || value === undefined || value === '') return '—'
  const number = Number(value)
  if (Number.isNaN(number)) return '—'
  return number.toLocaleString('pt-BR')
}

export const formatPercent = value => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return '—'
  return `${Number(value).toFixed(1)}%`
}

/**
 * Converte minutos em "2h 15min". Passando de 24h, quebra em dias + as horas que
 * sobram: "1d 5h 00min" em vez de "29h 00min".
 */
export const formatDuration = minutes => {
  if (minutes === null || minutes === undefined || Number.isNaN(Number(minutes))) return '—'
  const total = Math.round(Number(minutes))
  const days = Math.floor(total / 1440)
  const hours = Math.floor((total % 1440) / 60)
  const rest = total % 60
  const min = `${String(rest).padStart(2, '0')}min`
  if (days > 0) return `${days}d ${hours}h ${min}`
  if (hours > 0) return `${hours}h ${min}`
  return `${rest}min`
}

export const toIsoDate = value => (value ? new Date(value).toISOString() : '')
